import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const saveParsedPriceFactors = (parsedValues) => apiActionCreator({
  'endpoint': '/price-factors/',
  'authenticated': true,
  'types': [
    ActionTypes.SAVE_PRICE_FACTORS_REQUEST,
    [
      {'type': ActionTypes.SAVE_PRICE_FACTORS_SUCCESS},
      (response) => buildSuccessMessage(response, 'Información subida satisfactoriamente'),
    ],
    [
      ActionTypes.SAVE_PRICE_FACTORS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': parsedValues,
});

export const upsertPriceFactor = (data) => apiActionCreator({
  'endpoint': '/price-factors/upsert',
  'authenticated': true,
  'types': [
    ActionTypes.UPSERT_PRICE_FACTOR_REQUEST,
    [
      ActionTypes.UPSERT_PRICE_FACTOR_SUCCESS,
      MessageActions.addMessageBoxInfo('Factor de precio almacenado satisfactoriamente'),
    ],
    [
      ActionTypes.UPSERT_PRICE_FACTOR_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});
